// Settings.tsx (v4) — PWA V2 slice 4. The guide's "TweaksPanel" slot: a
// full-screen Settings overlay opened from the gear on the v4 ScreenHeader.
// Reuses the legacy SettingsScreen wholesale (API URL config, Google OAuth
// sign-in, push notification subscribe/unsubscribe, 4-theme picker, Auto-COS
// mode toggle, danger-zone reset) — the v4 self-promo card is suppressed and
// an explicit "classic PWA" escape hatch is offered instead.

import { SettingsScreen as LegacySettingsScreen } from "../../screens/Settings.js";

export function SettingsOverlay({ onClose }: { onClose: () => void }) {
  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 120,
        background: "var(--bg)",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <header
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "10px 12px",
          borderBottom: "1px solid var(--border-soft)",
          background: "var(--bg-bar)",
          flexShrink: 0,
        }}
      >
        <button
          onClick={onClose}
          style={{
            background: "none",
            border: "none",
            color: "var(--accent)",
            fontFamily: "var(--font-mono)",
            fontSize: 12,
            fontWeight: 700,
            cursor: "pointer",
            padding: "8px 10px",
          }}
        >
          ‹ Back
        </button>
        <span style={{ fontSize: 14, fontWeight: 600 }}>Settings</span>
        <button
          onClick={() => {
            window.location.hash = "legacy";
          }}
          title="Exit to the classic (legacy) PWA shell"
          style={{
            background: "none",
            border: "none",
            color: "var(--text-dim)",
            fontFamily: "var(--font-mono)",
            fontSize: 10,
            cursor: "pointer",
            padding: "8px 10px",
          }}
        >
          classic ›
        </button>
      </header>
      <div style={{ flex: 1, overflowY: "auto", minHeight: 0 }}>
        <LegacySettingsScreen showV4Link={false} />
      </div>
    </div>
  );
}
